"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _link = _interopRequireDefault(require("cccisd-icons/link"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _BulkThumbnailForm = _interopRequireDefault(require("./BulkThumbnailForm"));
var _EditResourceForm = _interopRequireDefault(require("./EditResourceForm"));
var _ResourceForm = _interopRequireDefault(require("./ResourceForm"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd.boilerplate;

// we use the metadata field in a resource to store data particular to that resource's type
/*
  i.e. type = Video
          metadata: {embed: <iframe>, runtime: 1:23:45}
*/
function getInitialValues(resource) {
  var initialValues = {};
  switch (resource.type) {
    case 'course':
      initialValues = {
        courseCustomUrl: resource.metadata.courseCustomUrl || '',
        deploymentId: resource.metadata.deploymentId || '',
        showCreditHours: resource.metadata.showCreditHours || false,
        showCourseSectionHeaders: resource.metadata.showCourseSectionHeaders || false,
        showMainIntroduction: resource.metadata.showMainIntroduction || false,
        showMoreInfoButton: resource.metadata.showMoreInfoButton || false,
        moreInfoButtonTitle: resource.metadata.moreInfoButtonTitle || '',
        moreInfoButtonContent: resource.metadata.moreInfoButtonContent || ''
      };
      break;
    case 'document':
      initialValues = {
        fileUpload: resource.fileUpload
      };
      break;
    case 'link':
      initialValues = {
        link: resource.metadata.link
      };
      break;
    case 'product':
      initialValues = {
        product: resource.product,
        link: resource.metadata.link,
        learnMore: resource.metadata.learnMore,
        hasLicense: !!resource.product,
        cost: resource.metadata.cost,
        isExternal: resource.metadata.isExternal
      };
      break;
    case 'video':
      initialValues = {
        embed: resource.metadata.embed,
        runtime: resource.metadata.runtime
      };
      break;
    default:
  }
  var commonInitialValues = _objectSpread(_objectSpread({}, resource), {}, {
    imageStyle: resource.metadata && resource.metadata.imageStyle || 'cover',
    searchTerms: resource.searchTerms || ''
  });
  return _objectSpread(_objectSpread({}, commonInitialValues), initialValues);
}
var Resources = /*#__PURE__*/function (_React$Component) {
  _inherits(Resources, _React$Component);
  var _super = _createSuper(Resources);
  function Resources() {
    var _this;
    _classCallCheck(this, Resources);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      resources: null,
      defaultTypes: null,
      selectedRows: [],
      persistSelectedRows: []
    });
    _defineProperty(_assertThisInitialized(_this), "bulkIconModalRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "getDefaultThumbnails", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, defaultTypes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.thumbnail.defaults'));
            case 2:
              response = _context.sent;
              defaultTypes = response.data.data;
              _this.setState({
                defaultTypes: defaultTypes
              });
              _this.getData();
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.getDefaultThumbnails();
    });
    _defineProperty(_assertThisInitialized(_this), "getData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var params, response, resources;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = {
                published: 'both'
              };
              _context2.next = 3;
              return _cccisdAxios["default"].get(Boilerplate.route('api.resources.resource.index'), {
                params: params
              });
            case 3:
              response = _context2.sent;
              resources = response.data.data.map(function (item) {
                var metadata = JSON.parse(item.draft_metadata !== null && item.draft_metadata.length > 0 ? item.draft_metadata : item.published_metadata);
                var url = item.url;
                if (!url && item.type === 'link') {
                  url = metadata.link;
                } else if (!url && item.type === 'video') {
                  var template = document.createElement('template');
                  template.innerHTML = metadata.embed.trim();
                  url = template.content.firstChild.getAttribute('src');
                }
                return {
                  id: item.id,
                  thumbnail: {
                    id: item.draft_thumbnail_id ? item.draft_thumbnail_id : item.published_thumbnail_id,
                    small: item.small,
                    large: item.large
                  },
                  tags: Object.keys(item.tags || {}).map(function (n) {
                    return parseInt(n, 10);
                  }),
                  tagObjects: item.tags || {},
                  title: item.draft_label,
                  type: item.type,
                  internalName: item.handle,
                  description: item.draft_description ? item.draft_description : item.published_description,
                  metadata: metadata,
                  searchTerms: item.search_terms,
                  published: !!item.is_published,
                  updated: item.updated_at,
                  edited: item.is_edited,
                  fileUpload: {
                    name: item.filename
                  },
                  url: url,
                  product: item.product_id
                };
              });
              _this.setState({
                loading: false,
                resources: resources
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "setSelectedRows", function (selectedRows) {
      if (selectedRows.length !== _this.state.selectedRows.length) {
        _this.setState({
          selectedRows: selectedRows
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "togglePublished", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id, isPublished) {
        var params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  publish: !isPublished
                };
                _context3.next = 3;
                return _cccisdAxios["default"].put(Boilerplate.route('api.resources.resource.update', {
                  resource: id
                }), params);
              case 3:
                _this.getData();
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "deleteResource", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _cccisdAxios["default"]["delete"](Boilerplate.route('api.resources.resource.destroy', {
                  resource: id
                }));
              case 2:
                _this.getData();
              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(Resources, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var ref = this;
      var _this$state = this.state,
        resources = _this$state.resources,
        defaultTypes = _this$state.defaultTypes,
        persistSelectedRows = _this$state.persistSelectedRows,
        selectedRows = _this$state.selectedRows;
      var columns = [{
        name: 'actions',
        label: 'Actions',
        render: function render(value, row) {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              className: "btn btn-success btn-xs"
            }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: "Edit",
              placement: "top"
            }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))),
            title: "Edit resource \"".concat(row.title, "\"")
          }, /*#__PURE__*/_react["default"].createElement(_EditResourceForm["default"], {
            getData: _this2.getData,
            initialValues: getInitialValues(row)
          })), ' ', /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-danger btn-xs",
            onClick: function onClick() {
              (0, _cccisdConfirm["default"])({
                message: 'Are you sure?',
                description: 'You are about to delete a resource!'
              }).then(function () {
                _this2.deleteResource(row.id);
                (0, _cccisdNotification["default"])({
                  message: 'Resource deleted.',
                  type: 'success'
                });
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Delete",
            placement: "top"
          }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))), ' ', row.url && /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-warning btn-xs",
            onClick: function onClick() {
              var isSuccess = (0, _copyToClipboard["default"])(row.url);
              (0, _cccisdNotification["default"])({
                message: isSuccess ? 'Copied URL to clipboard' : 'Could not copy URL to clipboard.',
                type: isSuccess ? 'success' : 'danger'
              });
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: "Copy URL",
            placement: "top"
          }, /*#__PURE__*/_react["default"].createElement(_link["default"], null))));
        },
        "class": _style["default"].actions
      }, {
        name: 'id',
        label: 'ID',
        sort: true,
        filter: false
      }, {
        name: 'thumbnail',
        label: 'Thumbnail',
        render: function render(value, row, callbacks) {
          var thumb = defaultTypes.find(function (item) {
            return item.handle === row.type;
          });
          var thumbnail = thumb.file && thumb.file.thumbnail;
          if ((!row || !row.thumbnail || !row.thumbnail.small) && !thumbnail) {
            return null;
          }
          return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("img", {
              width: "50px",
              className: _style["default"].thumbnail + ' center-block',
              src: row.thumbnail.small ? row.thumbnail.small : thumbnail.small_url,
              alt: ""
            }),
            title: 'Thumbnail for "' + row.title + '"'
          }, /*#__PURE__*/_react["default"].createElement("img", {
            className: "center-block",
            src: row.thumbnail.large ? row.thumbnail.large : thumbnail.large_url,
            alt: ""
          }));
        }
      }, {
        name: 'title',
        label: 'Resource Title',
        sort: true,
        filter: true,
        render: function render(value, row, callbacks) {
          switch (row.type) {
            case 'course':
              return row.title;
            case 'product':
              {
                if (!row.product) {
                  return /*#__PURE__*/_react["default"].createElement("a", {
                    href: row.metadata.link,
                    target: "_BLANK",
                    rel: "noopener noreferrer"
                  }, row.title);
                }
                return row.title;
              }
            case 'document':
              return /*#__PURE__*/_react["default"].createElement("a", {
                href: row.url,
                target: "_BLANK",
                rel: "noopener noreferrer"
              }, row.title);
            case 'link':
              return /*#__PURE__*/_react["default"].createElement("a", {
                href: row.metadata.link,
                target: "_BLANK",
                rel: "noopener noreferrer"
              }, row.title);
            case 'video':
              return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
                trigger: /*#__PURE__*/_react["default"].createElement("a", null, row.title),
                title: "I am a modal"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                dangerouslySetInnerHTML: {
                  __html: row.metadata.embed
                }
              }));
            default:
          }
        }
      }, {
        name: 'internalName',
        label: 'Internal Name',
        sort: true,
        filter: true
      }, {
        name: 'tags',
        label: 'Tags',
        filter: true,
        filterSettings: {
          type: 'text',
          custom: function custom(row, value) {
            return Object.values(row.tagObjects).some(function (tag) {
              return tag.toLowerCase().includes(value.toLowerCase());
            });
          }
        },
        render: function render(value, row, callbacks) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].tagField
          }, Object.keys(row.tagObjects).map(function (k, i) {
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: row.tagObjects[k],
              className: _cccisdStyleBible["default"].tag
            }, row.tagObjects[k]);
          }));
        }
      }, {
        name: 'updated',
        label: 'Last Edited',
        "class": 'text-center'
      }, {
        name: 'published',
        label: 'Published',
        sort: true,
        render: function render(value, row, callbacks) {
          var warn = null;
          if (row.edited && row.published) {
            warn = /*#__PURE__*/_react["default"].createElement("div", {
              className: "text-danger",
              style: {
                marginRight: '1em'
              }
            }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: "This resource has unpublished changes. Edit the resource with the 'Publish on save' toggle on in order to publish these changes.",
              placement: "top"
            }, /*#__PURE__*/_react["default"].createElement(_warning["default"], null)));
          }
          return /*#__PURE__*/_react["default"].createElement("div", {
            "data-toggle": row.published,
            style: {
              display: 'flex',
              justifyContent: 'center'
            }
          }, warn, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
            value: row.published,
            onChange: function onChange() {
              return ref.togglePublished(row.id, row.published);
            }
          }));
        }
      }];
      var rowActions = [{
        name: "Change Thumbnails",
        isConfirm: false,
        buttonText: "Change Thumbnails",
        action: function action(data) {
          var resourceIdMapping = resources.reduce(function (total, curr) {
            total[curr.id] = curr.title;
            return total;
          }, {});
          var persisted = data.map(function (id) {
            return {
              id: id,
              title: resourceIdMapping[id]
            };
          });

          // when this function finishes, rows are automatically unselected,
          // so we need persistSelectedRows to hold it in state
          _this2.setState({
            persistSelectedRows: persisted
          }, function () {
            if (_this2.bulkIconModalRef && _this2.bulkIconModalRef.current) {
              _this2.bulkIconModalRef.current.open();
            }
          });
        }
      }];
      if (this.state.loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "Resources"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: 'btn btn-primary ' + _style["default"].addBtn
        }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add Resource"),
        title: "Create New Resource"
      }, /*#__PURE__*/_react["default"].createElement(_ResourceForm["default"], {
        getData: this.getData
      })), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: this.bulkIconModalRef,
        render: function render(_ref5) {
          var closeModal = _ref5.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_BulkThumbnailForm["default"], {
            selectedRows: persistSelectedRows,
            closeModal: closeModal
          });
        },
        title: "Change ".concat(persistSelectedRows.length, " Thumbnails"),
        afterClose: this.getData
      }), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        className: "table table-striped table-bordered",
        columns: columns,
        data: resources,
        isAscentOrder: false,
        orderBy: "id",
        isCsvDownload: false,
        selectedRows: selectedRows,
        rowSelectedCallback: this.setSelectedRows,
        rowActions: rowActions
      }));
    }
  }]);
  return Resources;
}(_react["default"].Component);
exports["default"] = Resources;